<template>
  <v-card class="page-card">
    <v-toolbar color="primary" class="page-toolbar">
      <v-toolbar-title>Historial de retiros</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-text-field
        v-model="search"
        append-inner-icon="search"
        label="Buscar..."
        single-line
        hide-details
        variant="solo-filled"
        density="comfortable"
      />
    </v-toolbar>
    <div class="table-wrapper">
      <v-data-table
        :headers="headers"
        :items="withdrawedAgrochemicals"
        :search="search"
        :items-per-page-options="CONST.ROWS_PER_PAGE_ITEMS"
        :items-per-page-text="CONST.ROWS_PER_PAGE_TEXT">
        <template #[`item.date`]="{ item }">
          {{ formatLocalDate(getRawItem(item).date) }}
        </template>
        <template #[`item.agrochemical.name`]="{ item }">
          {{ getRawItem(item).agrochemical?.name || '' }}
        </template>
        <template #[`item.agrochemical.activePrincipie`]="{ item }">
          {{ getRawItem(item).agrochemical?.activePrincipie || '' }}
        </template>
        <template #no-data>
          <span>{{ CONST.NO_RESULTS_CHECK_FILTERS }}</span>
          <v-btn color="primary" class="ml-3" @click="initialize">{{ CONST.REFRESH }}</v-btn>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>
<script>
import CONST from '../../services/common/Constants.js'
import { mapGetters } from 'vuex'
import { formatLocalDate as formatDate } from '../../services/common/UtilsFunctions'

export default {
  name: 'WithdrawAgrochemicalTable',
  data: () => ({
    CONST: {},
    search: '',
    headers: [
      {title: 'Orden de trabajo', align: 'center', key: 'workOrderId'},
      {title: 'Fecha de Retiro', align: 'center', key: 'date'},
      {title: 'Agroquimico', align: 'center', key: 'agrochemical.name'},
      {title: 'Principio Activo', align: 'center', key: 'agrochemical.activePrincipie'},
      {title: 'Cantidad', align: 'center', key: 'amount'}
    ],
    withdrawedAgrochemicals: []
  }),

  computed: {
    ...mapGetters(['isRefreshTableRequired'])
  },

  created () {
    this.CONST = CONST
    this.initialize()
  },

  watch: {
    'isRefreshTableRequired': function (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.initialize()
      }
    }
  },

  methods: {
    getRawItem (item) {
      return item.raw || item
    },

    formatLocalDate (value) {
      return formatDate(value)
    },

    initialize () {
      this.$store.dispatch('agrochemicalModule/getWithdrawedAgrochemicals').then(() => {
        this.withdrawedAgrochemicals = this.$store.getters['agrochemicalModule/getWithdrawedAgrochemicals']
      })
    }
  }
}
</script>
